import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// eslint-disable-next-line import/no-unresolved
import classes from "./StudentEndSidebarItem.scss";
import _ from "lodash";
import { TickSmallOutlined } from "@toddle-edu/ds-icons";
import { isVisualWorksheetElement } from "Worksheet/modules/WorksheetUtils";
import { MODE_TEACHER_PREVIEW } from "../../../modules/WorksheetConstants";

const StudentEndSidebarItem = props => {
  const {
    id,
    tier,
    label,
    childOptions,
    isCompleted,
    isNotClickable,
    isQuestion,
    maxMarks,
    collapsedState,
    questionIndex,
    questionTypeUid,
    icon,
    activeQuestion,
    updateActiveQuestion,
    instructionsActive,
    mode,
  } = props;

  const filteredChildOptions = _.filter(
    childOptions,
    child => !isVisualWorksheetElement(child.questionTypeUid)
  );

  const isActive = id === activeQuestion && !instructionsActive;

  const handleItemClick = () => {
    if (instructionsActive) return;
    if (isQuestion && !isNotClickable && updateActiveQuestion) {
      updateActiveQuestion(id);
    }
  };

  const handleKeyDown = event => {
    if (
      (event.key === "Enter" || event.key === " ") &&
      isQuestion &&
      !isNotClickable
    ) {
      event.preventDefault();
      handleItemClick();
    }
  };

  const containerClasses = classNames({
    [classes.subLevel]: tier > 0,
    [classes.divider]: true,
    [classes.collapsedState]: collapsedState,
    [classes.subLevelQuestion]: isQuestion && tier > 1,
    [classes.activeItem]: isActive && isQuestion,
    [classes.clickable]: isQuestion && !isNotClickable && !instructionsActive,
  });

  const labelClasses = classNames({
    [classes.labelSmall]: !isQuestion,
    "text-body-2": isQuestion,
    [classes.questionLabel]: isQuestion,
    [classes.questionLabelActive]: isActive && isQuestion,
    [classes.labelEllipsis]: !collapsedState || (collapsedState && !isQuestion),
    [classes.expandedView]: !collapsedState,
  });

  const itemLabelClasses = classNames({
    [classes.itemLabel]: true,
    [classes.Lbefore]: tier > 2,
  });

  const tickClasses = classNames({
    [classes.tick]: true,
    [classes.tickVisible]: isCompleted && isQuestion,
  });
  return (
    <>
      <div
        className={containerClasses}
        onClick={handleItemClick}
        onKeyDown={handleKeyDown}
        role={isQuestion && !isNotClickable ? "button" : undefined}
        tabIndex={isQuestion && !isNotClickable ? 0 : undefined}
        aria-selected={isActive}
      >
        {collapsedState ? (
          <>
            <span className={labelClasses}>
              {isQuestion ? questionIndex : label}
            </span>
            <TickSmallOutlined
              variant="success"
              size="x-small"
              className={tickClasses}
            />
          </>
        ) : (
          <div className={classes.expandedItemContent}>
            <span className={itemLabelClasses}>
              {isQuestion && <span>{icon}</span>}
              <span className={labelClasses}>{label}</span>
            </span>
            <span className={classes.marksSection}>
              {isQuestion && <span>{maxMarks}</span>}
              {!_.isEqual(mode, MODE_TEACHER_PREVIEW) ? (
                <TickSmallOutlined
                  variant="success"
                  size="x-small"
                  className={tickClasses}
                />
              ) : null}
            </span>
          </div>
        )}
      </div>
      {_.map(filteredChildOptions, (child, key) => {
        return (
          <>
            {_.isEqual(key, 0) && questionTypeUid && (
              <div className={classes.borderBottom} />
            )}
            <StudentEndSidebarItem
              key={child.id}
              {...child}
              collapsedState={collapsedState}
              activeQuestion={activeQuestion}
              updateActiveQuestion={updateActiveQuestion}
              mode={mode}
            />
            {!_.isEqual(key, _.size(filteredChildOptions) - 1) && (
              <div className={classes.borderBottom} />
            )}
          </>
        );
      })}
    </>
  );
};

StudentEndSidebarItem.propTypes = {
  label: PropTypes.string.isRequired,
  isQuestion: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  activeQuestion: PropTypes.string,
  updateActiveQuestion: PropTypes.func,
  isNotClickable: PropTypes.bool,
};

StudentEndSidebarItem.defaultProps = {
  activeQuestion: null,
  updateActiveQuestion: null,
  isNotClickable: false,
};

export default StudentEndSidebarItem;
